import styles from "./taskdetails.module.css";
import TaskCheckList from "./TaskCheckList";
import { Calendar, ChevronDown, User, X } from "react-feather";
import { styled } from "@mui/material/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import DateRangePicker from "rsuite/DateRangePicker";
import dayjs from "dayjs";
import { Tooltip } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { Dropdown } from "react-bootstrap";
import { useAuth0 } from "@auth0/auth0-react";
import { useState, useEffect } from "react";
import { toast } from "react-smart-toaster";
import { TableLoaderSmall } from "../../../components/LoaderC";
import axios from "axios";
import { AddLogCallAPI } from "../../../components/AddLogs";

const BootstrapTooltip = styled(({ className, ...props }) => (<Tooltip {...props} arrow classes={{ popper: className }} />))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    fontSize: 13,
  },
}));

const TaskDetails = ({ setDetailsTaskModalOpen, selectedId, setLoading, setSnackbarOpen, setSnackbarMsg }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [contentLoading, setContentLoading] = useState(true);
  const [taskDetails, setTaskDetails] = useState(null);
  const [selectedWeek, setSelectedWeek] = useState([dayjs().subtract(6, 'days').toDate(), dayjs().toDate()]);
  const [taskCheckList, setTaskCheckList] = useState([]);
  const [archiveTaskModalOpen, setArchiveTaskModalOpen] = useState(false);
  const [isArchive, setIsArchive] = useState(false);
  const [minDate, setMinDate] = useState(dayjs().toDate());

  const disableDate = (date) => {
    const d = dayjs(date);
    return d.isBefore(minDate, "day");
  };

  useEffect(() => {
    async function fetchTaskDetails() {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_CASE_API_URL + "v1/tasks/" + selectedId, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        setContentLoading(false);
        setTaskDetails(response.data.data);

        setMinDate(dayjs(response.data.data?.start_date).toDate());
      }).catch(() => {
        setContentLoading(false);
      });
    }
    if (selectedId) fetchTaskDetails();
  }, [selectedId, getAccessTokenSilently]);

  useEffect(() => {
    async function fetchTaskChecklist(startDate, endDate) {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_CASE_API_URL + "v1/tasks-check-list?task_id=" + selectedId + "&start=" + startDate + "&end=" + endDate, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        setTaskCheckList(response.data.data);
      }).catch(() => { });
    }

    if (selectedWeek) {
      let startDate = dayjs(selectedWeek[0]).format("YYYY-MM-DD");
      let endDate = dayjs(selectedWeek[1]).format("YYYY-MM-DD");

      fetchTaskChecklist(startDate, endDate);
    }
  }, [selectedWeek, selectedId]);

  const statusChangeConfirm = async () => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    setArchiveTaskModalOpen(false);
    setLoading(true);

    let data = { is_archived: 0 };
    if (isArchive) {
      data = { is_archived: 1 };
    }

    axios.put(process.env.REACT_APP_CASE_API_URL + "v1/tasks/" + selectedId, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);
      setTaskDetails((prev) => ({ ...prev, is_archived: isArchive ? 1 : 0 }));

      setSnackbarMsg(response.data.message);
      setSnackbarOpen(true);

      let logData = {
        title: isArchive ? "Task list has been disabled" : "Task list has been enabled",
        description: [
          "Name: " + response?.data?.data?.title,
          "Property: " + response?.data?.data?.property_name,
          "Technician: " + response?.data?.data?.technician_name,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  const onCheckList = async (listId, isChecked) => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    let data = { is_checked: isChecked ? 1 : 0 };

    axios.put(process.env.REACT_APP_CASE_API_URL + "v1/check-list-admin/" + listId, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => { })
      .catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
        setLoading(false);
      });
  }

  const saveAnswer = async (data, task) => {
    let newData = { ...data, is_checked: 1 };

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.put(process.env.REACT_APP_CASE_API_URL + "v1/check-list-admin/" + task?.id, newData, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(() => {
      let logData = {
        title: "A task has been checked.",
        description: [
          "Task Name: " + task.task_list,
          "List Name: " + task.task_name
        ],
      };

      AddLogCallAPI(logData, token);
    }).catch(() => { });
  }

  return (<>
    {contentLoading && (<div className="Loader TableLoader">
      <TableLoaderSmall />
    </div>)}

    {!contentLoading && (<>
      <div className={`${styles.PanelCloasesec}`}>
        <p>{taskDetails?.title}</p>
        <Dropdown onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
          <Dropdown.Toggle id="dropdown-basic" className={taskDetails?.is_archived === 1 ? `${styles.ReferStatusBU} ${styles.StatusBuRed}` : `${styles.ReferStatusBU} ${styles.StatusBuGreen}`}>
            {taskDetails?.is_archived === 1 ? "Disable" : "Enable"}{" "}
            <ChevronDown className={`${styles.DownArrowStatus}`} />
          </Dropdown.Toggle>

          <Dropdown.Menu className="DropDownMenuBoxCus">
            {taskDetails?.is_archived === 1 && (<Dropdown.Item className="DropDListWIcon" onClick={(e) => { setArchiveTaskModalOpen(true); setIsArchive(false); }}>Enable</Dropdown.Item>)}
            {taskDetails?.is_archived === 0 && (<Dropdown.Item className="DropDListWIcon" onClick={(e) => { setArchiveTaskModalOpen(true); setIsArchive(true); }}>Disable</Dropdown.Item>)}
          </Dropdown.Menu>
        </Dropdown>
        <div className={`${styles.SMProCardHeadBuSec}`}>
          {taskDetails?.technician_name !== '' && <button className={`${styles.PanelMailBU}`}>
            <BootstrapTooltip title={<div className={`${styles.IncomeLineTooltip}`}>
              <p>{taskDetails?.technician_name} Assigned</p>
            </div>}>
              <User />
            </BootstrapTooltip>
          </button>}
          {taskDetails?.days?.length > 0 && <button className={`${styles.PanelMailBU}`}>
            <BootstrapTooltip title={<div className={`${styles.IncomeLineTooltip}`}>
              {taskDetails?.days?.map((it, ind) => {
                return (<p key={ind}>#{ind + 1}. {it}</p>);
              })}
            </div>}>
              <Calendar />
            </BootstrapTooltip>
          </button>}
        </div>
        <button className={`${styles.close}`} onClick={(e) => setDetailsTaskModalOpen(false)}><X /></button>
      </div>
      <div className={`${styles.TaskDetailsBody}`}>
        <div className={`${styles.DetailsMemberSec}`}>
          <p className={`${styles.Title}`}>Description</p>
          <p className={`${styles.Description}`}>{taskDetails?.description}</p>
        </div>

        <div className={`${styles.SwitchDiv} FormGroup Filter`}>
          <div className={`${styles.DashFilterSec} DashFilterSec`}>
            <DateRangePicker
              format={"MM/dd/yyyy"}
              placeholder={"Filter by date"}
              placement={"bottomEnd"}
              caretAs={Calendar}
              showOneCalendar
              cleanable={false}
              disabledDate={disableDate}
              onChange={(e) => setSelectedWeek(e)}
              value={selectedWeek}
            />
          </div>
        </div>
        <div className="FormAccording TaskList Theme">
          <TaskCheckList taskCheckList={taskCheckList} setTaskCheckList={setTaskCheckList} onCheckList={onCheckList} saveAnswer={saveAnswer.bind(this)} />
        </div>
      </div>
    </>)}

    <Dialog
      open={archiveTaskModalOpen}
      onClose={(e) => setArchiveTaskModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to {isArchive ? "disable" : "enable"} task list?
        <button onClick={(e) => setArchiveTaskModalOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">The task will be {isArchive ? "disabled" : "enabled"}{" "}immediately. You can {isArchive ? "enable" : "disable"} it at any time.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <button onClick={(e) => setArchiveTaskModalOpen(false)} className="CancelPopupBU">Cancel</button>
        <button onClick={(e) => statusChangeConfirm(false)} className="SubmitPopupBU">Submit</button>
      </DialogActions>
    </Dialog>
  </>);
};

export default TaskDetails;